export default __webpack_public_path__ + "static/media/market_share.bb489573.svg";